<template>
  <div>
    <form>
      <div class="l-main-content">
        <div class="p-contact-edit">
          <ul class="p-contact-edit-list">
            <li class="p-contact-edit-list__item">
              <div
                class="c-input"
                :class="{'is-error': valid.company != ''}"
              >
                <div class="c-input__title">企業名</div>
                <input
                  v-model="company"
                  class="c-input__item"
                  type="text"
                  name="company"
                  value=""
                  placeholder="企業名を入力してください"
                  @blur="onChangeCompany"
                  @input="onChangeCompany"
                />
                <div
                  class="c-error c-error--balloon"
                  :class="{'is-active': valid.company != ''}"
                >
                  <div class="c-error__text">{{ valid.company }}</div>
                </div>
              </div>
            </li>

            <li class="p-contact-edit-list__item">
              <div
                class="c-input"
                :class="{'is-error': valid.name != ''}"
              >
                <div class="c-input__title">ご担当者名</div>
                <input
                  v-model="name"
                  class="c-input__item"
                  type="text"
                  name="name"
                  value=""
                  placeholder="ご担当者名を入力してください"
                  @blur="onChangeName"
                  @input="onChangeName"
                />
                <div
                  class="c-error c-error--balloon"
                  :class="{'is-active': valid.name != ''}"
                >
                  <div class="c-error__text">{{ valid.name }}</div>
                </div>
              </div>
            </li>

            <li class="p-contact-edit-list__item">
              <div
                class="c-input"
                :class="{'is-error': valid.phone != ''}"
              >
                <div class="c-input__title">お電話番号</div>
                <input
                  v-model="phone"
                  class="c-input__item"
                  type="text"
                  name="phone"
                  value=""
                  placeholder="お電話番号を入力してください"
                  @blur="onChangePhone"
                  @input="onChangePhone"
                />
                <div
                  class="c-error c-error--balloon"
                  :class="{'is-active': valid.phone != ''}"
                >
                  <div class="c-error__text">{{ valid.phone }}</div>
                </div>
              </div>
            </li>

            <li class="p-contact-edit-list__item">
              <div
                class="c-input"
                :class="{'is-error': valid.email != ''}"
              >
                <div class="c-input__title">ご連絡用メールアドレス</div>
                <input
                  v-model="email"
                  class="c-input__item"
                  type="text"
                  name="email"
                  value=""
                  placeholder="ご連絡用メールアドレスを入力してください"
                  @blur="onChangeEmail"
                  @input="onChangeEmail"
                />
                <div
                  class="c-error c-error--balloon"
                  :class="{'is-active': valid.email != ''}"
                >
                  <div class="c-error__text">{{ valid.email }}</div>
                </div>
              </div>
            </li>

            <li class="p-contact-edit-list__item">
              <div
                class="c-radio"
                :class="{'is-error': valid.contactType != ''}"
              >
                <div class="c-radio__title">お問い合わせ内容</div>
                <ul class="c-radio-list">
                  <li v-for="(typeName, type) in contactTypes" :key="type" class="c-radio-list__item">
                    <label class="c-radio__label">
                      <input
                        v-model="contactType"
                        type="radio"
                        name="contact_type"
                        :value="type"
                        @change="onChangeContactType"
                      />
                      <div class="c-radio__item">
                        <div class="c-radio__box"></div>
                        <div class="c-radio__box-label">{{ typeName}} </div>
                      </div>
                    </label>
                  </li>
                </ul>
                <div
                  class="c-error"
                  :class="{'is-active': valid.contactType != ''}"
                >
                  <div class="c-error__text">{{ valid.contactType }}</div>
                </div>
              </div>
            </li>
            <li class="p-contact-edit-list__item">
              <div
                ref="refInputContent"
                class="c-textarea"
                :class="{'is-error': valid.content != ''}"
              >
                <textarea
                  v-model="content"
                  class="c-textarea__item"
                  name="content"
                  placeholder="お問い合わせ内容を入力してください"
                  @blur="onChangeContent"
                  @input="onChangeContent"
                ></textarea>
                <div
                  class="c-error c-error--balloon"
                  :class="{'is-active': valid.content != ''}"
                >
                  <div class="c-error__text">{{ valid.content }}</div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-contact-btns">
          <a
            class="c-btn c-btn--gray u-w320 u-h50 u-fs--xl"
            @click="onCancelClick"
          >
            <p class="c-btn__text">キャンセル</p>
          </a>
          <button
            :class="{'is-loading': isLoading}"
            class="c-btn c-btn--blue u-w320 u-h50 u-fs--xl"
            type="button"
            name="edit"
            value="edit"
            :disabled="isLoading || !isValid()"
            @click="onSubmitClick"
          >
            <p class="c-btn__text">送信する</p>
          </button>
        </div>
      </div>

      <!-- モーダル: 完了メッセージ表示 -->
      <control-modal
        ref="refCompleteModal"
        classes="c-modal--contact"
        :title="completeTitle"
        :body="completeMessage"
        cancel-button-label="前のページに戻る"
        :is-active=isCompleteMessage
        :on-close-click="onCloseControlModal"
        :on-cancel-click="onCancelControlModal"
      />

      <!-- モーダル: エラーメッセージ表示 -->
      <error-modal
        :is-active=isError
        :message=errorMessage
        :on-close-click="onCloseErrorModal"
      />
    </form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    contactTypes: Object,
  },
  data: () => {
    return {
      completeTitle: 'お問い合わせ、ありがとうございます。',
      completeMessage: '入力いただきました内容を受付いたしました。●営業日以内に追って担当者よりご連絡差し上げます。', // TODO
      button: '前のページに戻る',
      url: 'javascript:history.back();',

      company: null,
      name: null,
      phone: null,
      email: null,
      contactType: null,
      content: null,
      errorMessage: '',
      isCompleteMessage: false,
      isError: false,
      isLoading: false,
      valid: {
        company: '',
        name: '',
        phone: '',
        email: '',
        contactType: '',
        content: '',
      },
    }
  },
  methods: {
    isValid: function() {
      return (
        this.valid.company == '' &&
        this.valid.name == '' &&
        this.valid.phone == '' &&
        this.valid.email == '' &&
        this.valid.contactType == '' &&
        this.valid.content == ''
      ) ? true : false ;
    },

    onCancelClick: function() {
      this.backToPreviousPage();
    },

    onChangeCompany: function() {
      if (!this.company || this.company == '') {
        this.valid.company = '企業名を入力してください';
      } else {
        this.valid.company = '';
      }
    },

    onChangeName: function() {
      if (!this.name || this.name == '') {
        this.valid.name = 'ご担当者名を入力してください';
      } else {
        this.valid.name = '';
      }
    },

    onChangePhone: function() {
      if (!this.phone || this.phone == '') {
        this.valid.phone = '電話番号を入力してください';
      } else {
        this.valid.phone = '';
      }
    },

    onChangeEmail: function() {
      if (!this.email || this.email == '') {
        this.valid.email = 'ご連絡用メールアドレスを入力してください';
      } else {
        this.valid.email = '';
      }
    },

    onChangeContactType: function() {
      if (!this.contactType || !this.contactTypes[this.contactType]) {
        this.valid.contactType = 'お問い合わせの種類を選択してください';
      } else {
        this.valid.contactType = '';
      }
    },

    onChangeContent: function() {
      if (!this.content || this.content == '') {
        this.valid.content = 'お問い合わせ内容を入力してください';
      } else {
        this.valid.content = '';
      }
    },

    onSubmitClick: function() {
      this.isLoading = true;

      // ペイロードデータの作成
      const data = {
        company: this.company,
        name: this.name,
        phone: this.phone,
        email: this.email,
        contact_type: this.contactType,
        content: this.content,
      };

      // 問い合わせ送信処理実行
      axios.post('/api/contact', data)
        .then(res => {
          if (this.handleResponse(res, false)) {
            this.isCompleteMessage = true;
          } else if (res && res.data && res.data.errors) {
            Object.keys(res.data.errors).forEach((index) => {
              if (typeof this.valid[this.camelCase(index)] === 'undefined') return;
              this.valid[this.camelCase(index)] = res.data.errors[index];
            });
            // TODO: 吹き出しエラーがある場合は、別途エラーモーダルも表示するのか？確認する事
            this.isError = true;
            this.errorMessage = 'お問い合わせ内容の送信に失敗しました'

          } else {
            this.isError = true;
            this.errorMessage = 'お問い合わせ内容の送信に失敗しました'
          }
          setTimeout(() => { this.isLoading = false; }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'お問い合わせ内容の送信に失敗しました'
          setTimeout(() => { this.isLoading = false; }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    onCloseControlModal: function() {
      this.isCompleteMessage = false;
    },

    onCancelControlModal: function() {
      this.isCompleteMessage = false;
      history.back();
    },
  },
}
</script>